import { Card, Divider } from "@mui/material";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import ReactTimeAgo from "react-time-ago";
import ThreeDotsMenu from "../../Subcomponents/ThreeDotsMenu";
import LeadStatusChip from "../../Subcomponents/LeadStatusChip";
import Dot from "../Icons/Dot";
import cssClasses from "./Home.module.css";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en.json";
import AllotmentBuildingIcon from "../../Assets/Images/Common/AllotmentBuildingIcon.svg";
import AllotmentprofileIcon from "../../Assets/Images/Common/AllotmentProfile.svg";
import AllotmentCalenderIcon from "../../Assets/Images/Common/AllotmentCalender.svg";
import AllotmentInfoIcon from "../../Assets/Images/Common/info-circle.svg";
import CancelUnit from "../../Modals/CancelUnit.js/CancelUnit";
import AllotmentDetails from "../AllotmentDetails/AllotmentDetails";
import { Tooltip } from "react-tooltip";
import VirtualAccount from "../../Modals/VirtualAccountDetails/VirtualAccount";
import useEsignFlow from "../../Modals/AllotmentEsign/useEsignFlow";
import { vaDetailsHidden, VA_AFTER_KYC_TEXT } from "../../Modals/AllotmentEsign/preselectKyc";
import Button from "../../Subcomponents/Button";
import { numberWithCommas } from "../../Assets/Common/CommonFunctions";
import AgreementKYC from "../../Modals/AgreementKYC/AgreementKYC";
import UnitCost from "../../Modals/UnitCost/UnitCost";

const BalanceOCRGST = ({ allotment }) => {
	const { newFlow } = useEsignFlow();
	let loggedInUser = {};
	loggedInUser = useSelector((state) => state.Auth.user);
	TimeAgo.setDefaultLocale(en.locale);
	TimeAgo.addLocale(en);
	const [allotmentDetails, setAllotmentDetails] = useState({});
	const [openCancelUnitModal, setOpenCancelUnitModal] = useState(false);
	const [showDetails, setShowDetails] = useState(false);
	const [amtData, setAmtData] = useState({ ocr: 0, gst: 0 });
	const [showVertualAccount, setShowVertualAccount] = useState(false);
	const [openAgreementKYCModal, setOpenAgreementKYCModal] = useState(false);
	const [showUnitCost, setShowUnitCost] = useState(false);

	useEffect(() => {
		if (allotment) {
			const ocrData = (allotment.unitCost?.bsp * 10) / 100;
			const gstData = ocrData * (allotment.unitCost?.gst / allotment.unitCost?.bsp); // @todo
			setAmtData({ ocr: ocrData, gst: gstData });
		}
	}, [allotment.unitCost, allotment]);
	return (
		<>
			<Card className={cssClasses.allotmentEventWrap} style={{ borderRadius: "20px", boxShadow: "none" }}>
				<div className={cssClasses.allotmentCardHeader}>
					<div className={cssClasses.allotmentTokenNumWrap}>
						<div className={cssClasses.allotmentImg}>
							<img src={AllotmentBuildingIcon} alt="allotment" />
						</div>
						<div className={cssClasses.allotmentProjectDetail}>
							<div className={cssClasses.allotmentProjectDetailFirst}>
								<span>
									{allotment?.unitId && (
										<span>
											{allotment?.unitId.wingId.displayName
												? allotment?.unitId.wingId.displayName
												: allotment?.unitId.wingId.wingName}{" "}
											- {allotment?.unitId.unitNo}
										</span>
									)}
									{allotment?.inventoryMergedId &&
										((allotment?.inventoryMergedId.unit1Id.wingId.wingId ===
											allotment?.inventoryMergedId.unit2Id.wingId.wingId && (
												<span>
													{allotment?.inventoryMergedId.unit1Id.wingId.displayName
														? allotment?.inventoryMergedId.unit1Id.wingId.displayName
														: allotment?.inventoryMergedId.unit1Id.wingId.wingName}{" "}
													- {allotment?.inventoryMergedId.unit1Id.unitNo} & {allotment?.inventoryMergedId.unit2Id.unitNo}{" "}
												</span>
											)) ||
											(allotment?.inventoryMergedId.unit1Id.wingId.wingId !==
												allotment?.inventoryMergedId.unit2Id.wingId.wingId && (
													<span>
														{allotment?.inventoryMergedId.unit1Id.wingId.displayName
															? allotment?.inventoryMergedId.unit1Id.wingId.displayName
															: allotment?.inventoryMergedId.unit1Id.wingId.wingName}{" "}
														- {allotment?.inventoryMergedId.unit1Id.unitNo} &{" "}
														{allotment?.inventoryMergedId.unit2Id.wingId.displayName
															? allotment?.inventoryMergedId.unit2Id.wingId.displayName
															: allotment?.inventoryMergedId.unit2Id.wingId.wingName}{" "}
														- {allotment?.inventoryMergedId.unit2Id.unitNo}{" "}
													</span>
												)))}
								</span>
								{allotment.paymentId?.eventTokenId?.tokenId.isPreselect && (
									<span>
										<LeadStatusChip
											label={"Preselect"}
											style={{
												color: "#FF7B01",
												border: "1px solid #FFC997",
												borderRadius: "0px",
											}}
										></LeadStatusChip>
									</span>
								)}
							</div>
							<div className={cssClasses.allotmentProjectName}>
								{allotment?.unitId && <span>{allotment?.unitId.projectId.projectName}</span>}
								{allotment?.inventoryMergedId && <span>{allotment?.inventoryMergedId.projectId.projectName}</span>}
							</div>
						</div>
					</div>
					<div className={cssClasses.allotmenttimeActionSection}>
						<div className={cssClasses.allotmentTokenLastUpdate}>
							<ReactTimeAgo style={{ fontSize: "1.2rem" }} date={allotment?.last_updated_at ?? allotment?.created_at} locale="en-US" />
						</div>
						<div className={cssClasses.tokenActions}>
							<ThreeDotsMenu
								list={allotment.menuOpt}
								selectedValue={(e) => {
									console.log(e);
									if (e === "View Details") {
										setAllotmentDetails(allotment);
										setShowDetails(true);
										// setScheduleSiteVisitModal(true);
									} else if (e === "Cancel Unit") {
										setOpenCancelUnitModal(true);
										setAllotmentDetails(allotment);
									}
								}}
							/>
						</div>
					</div>
				</div>
				<div style={{ width: "100%" }}>
					<div className={cssClasses.tokenStatus}>
						{allotment.status === "Payment Complete" || allotment.status === "Agreement Done" ? (
							<>
								{allotment.status.includes("Cancellation Pending") && (
									<LeadStatusChip
										label={"Cancellation Pending"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#B54708",
											backgroundColor: "#FFFAEB",
										}}
									></LeadStatusChip>
								)}
								{(allotment.status === "Cancelled" ||
									allotment.status === "Change Requested" ||
									allotment.status === "Cancellation Requested") && (
										<LeadStatusChip
											label={allotment.status}
											icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
											style={{
												color: "#B42318",
												backgroundColor: "#FEF3F2",
											}}
										></LeadStatusChip>
									)}
								{/* ? if 5,00,000 amount is paid; check for SDR amount */}
								{allotment.unitCost?.sdr - allotment.paidAmt?.sdr > 0 ? (
									<LeadStatusChip
										label={"SDR Pending"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#B54708",
											backgroundColor: "#FFFAEB",
										}}
									></LeadStatusChip>
								) : (
									<LeadStatusChip
										label={"SDR Complete"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#027A48",
											backgroundColor: "#ECFDF3",
										}}
									></LeadStatusChip>
								)}
								{!allotment.kycFormFilled && (
									<LeadStatusChip
										label={"Kyc pending"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#0E7090",
											backgroundColor: "#ECFDFF",
										}}
									></LeadStatusChip>
								)}
								{allotment.kycFormFilled && (
									<LeadStatusChip
										label={"Kyc Done"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#0E7090",
											backgroundColor: "#ECFDFF",
										}}
									></LeadStatusChip>
								)}
							</>
						) : (
							<>
								{allotment.status.includes("Cancellation Pending") && (
									<LeadStatusChip
										label={"Cancellation Pending"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#B54708",
											backgroundColor: "#FFFAEB",
										}}
									></LeadStatusChip>
								)}
								{(allotment.status === "cancelled" ||
									allotment.status === "Cancelled" ||
									allotment.status === "Cancellation Rejected" ||
									allotment.status === "Change Requested" ||
									allotment.status === "Cancellation Requested") && (
										<LeadStatusChip
											label={allotment.status}
											icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
											style={{
												color: "#B42318",
												backgroundColor: "#FEF3F2",
											}}
										></LeadStatusChip>
									)}
								{allotment.status === "Partial Payment Done" && (
									<LeadStatusChip
										label={allotment.status}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#B54708",
											backgroundColor: "#FFFAEB",
										}}
									></LeadStatusChip>
								)}
								{allotment.status === "Payment Pending" && (
									<LeadStatusChip
										label={"Payment Pending"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#B42318",
											backgroundColor: "#FEF3F2",
										}}
									></LeadStatusChip>
								)}
								{allotment.status === "expired" && (
									<LeadStatusChip
										label={"Expired"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#0E7090",
											backgroundColor: "#ECFDFF",
										}}
									></LeadStatusChip>
								)}
								{allotment.status === "On Hold" && (
									<LeadStatusChip
										label={allotment.status}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#3538CD",
											backgroundColor: "#EEF4FF",
										}}
									></LeadStatusChip>
								)}
								{(allotment.status === "Released" ||
									allotment.status === "Refund Processed" ||
									allotment.status === "Refund Initiated") && (
										<LeadStatusChip
											label={allotment.status}
											icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
											style={{
												color: "rgb(180, 35, 24)",
												backgroundColor: "rgb(254, 243, 242)",
											}}
										></LeadStatusChip>
									)}
								{allotment.status === "Partial Payment Done" && !allotment.kycFormFilled && (
									<LeadStatusChip
										label={"Kyc Pending"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#0E7090",
											backgroundColor: "#ECFDFF",
										}}
									></LeadStatusChip>
								)}
								{allotment.kycFormFilled && (
									<LeadStatusChip
										label={"Kyc Done"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#0E7090",
											backgroundColor: "#ECFDFF",
										}}
									></LeadStatusChip>
								)}
							</>
						)}
						{allotment?.leadId?.LeadsReferral.length > 0 && allotment?.leadId?.LeadsReferral[0]?.id &&
							<LeadStatusChip
								label="VJOP"
								style={{
									color: "rgb(180, 35, 24)",
									backgroundColor: "rgb(254, 243, 242)",
								}}
							></LeadStatusChip>
						}
					</div>
				</div>
				<div className={cssClasses.allotmentCpDetails}>
					<div className={cssClasses.allotmentCpDetailsContent}>
						<div className={cssClasses.allotmentPrice}>
							<div className={cssClasses.allotmentCpImg}>
								<img src={AllotmentprofileIcon} alt="profile" />
							</div>
							<div>
								<div className={cssClasses.allotmentCpText}>VJ Sales Manager : </div>
								<div>{loggedInUser?.userId?.name ?? "NA"}</div>
							</div>
						</div>
						<div className={cssClasses.allotmentPrice}>
							<div className={cssClasses.allotmentCpImg}>
								<img src={AllotmentprofileIcon} alt="profile" />
							</div>
							<div>
								<div className={cssClasses.allotmentCpText}>FOS : </div>
								<div>{loggedInUser?.fosId?.name ?? "NA"}</div>
							</div>
						</div>
					</div>
					<Divider orientation="vertical" variant="middle" flexItem />
					{/* <Divider orientation="vertical" variant="middle" flexItem /> */}
					<div className={cssClasses.allotmentCpDetailsContent}>
						<div className={cssClasses.allotmentPrice}>
							<div className={cssClasses.allotmentCpImg}>
								<img src={AllotmentprofileIcon} alt="profile" />
							</div>
							<div>
								<div className={cssClasses.allotmentCpText}>Channel Partner : </div>
								<div>{loggedInUser?.cpId?.billingName ?? "NA"}</div>
							</div>
						</div>
					</div>
				</div>
				<div className={cssClasses.allotmentCardData}>
					<div className={cssClasses.allotmentCardDetails}>
						<div className={cssClasses.allotmentEventData}>
							<div className={cssClasses.allotmentTokenData}>
								<span className={cssClasses.AllotmentEventName}>{allotment.paymentId?.eventTokenId?.eventId?.title}</span>
							</div>
							<div className={cssClasses.allotmentUnitDetails}>
								{allotment?.unitId?.inventoryTypeId?.type &&
									allotment?.unitId?.projectId?.customerDisplayInventoryType?.includes("Inventory Type") ? (
									<span>{allotment?.unitId?.inventoryTypeId?.type} • </span>
								) : (
									""
								)}
								{allotment?.unitId?.displayUnitType &&
									allotment?.unitId?.projectId?.customerDisplayInventoryType?.includes("Display Unit Type") ? (
									<span>{allotment?.unitId?.displayUnitType} • </span>
								) : (
									""
								)}
								{/* } */}
								{allotment.inventoryMergedId && (
									<>
										{/* {allotment.inventoryMergedId.unit1Id.inventoryTypeId.type === allotment.inventoryMergedId.unit2Id.inventoryTypeId.type &&
                                                    <span>{allotment.inventoryMergedId.unit1Id.inventoryTypeId.type}</span>
                                                }
                                                {allotment.inventoryMergedId.unit1Id.inventoryTypeId.type !== allotment.inventoryMergedId.unit2Id.inventoryTypeId.type && */}
										<span>
											{allotment.inventoryMergedId.unit1Id.inventoryTypeId.type} -{" "}
											{allotment.inventoryMergedId.unit2Id.inventoryTypeId.type}
										</span>
										{/* } */}
									</>
								)}

								{allotment.unitId && <span>{allotment.unitId.floorNo}</span>}
								<span>{" • "}</span>
								{allotment.unitId && (
									// <span>Area {allotment.unitId.chargeableArea} sq.ft</span>
									<span>Area {allotment.unitId.saleableArea} sq.ft</span>
								)}
								{allotment.inventoryMergedId && (
									<>
										{allotment.inventoryMergedId.unit1Id.floorNo === allotment.inventoryMergedId.unit2Id.floorNo && (
											<span>{allotment.inventoryMergedId.unit1Id.floorNo}</span>
										)}
										{allotment.inventoryMergedId.unit1Id.floorNo !== allotment.inventoryMergedId.unit2Id.floorNo && (
											<span>
												{allotment.inventoryMergedId.unit1Id.floorNo} - {allotment.inventoryMergedId.unit2Id.floorNo}
											</span>
										)}
									</>
								)}
								{allotment.inventoryMergedId && (
									<>
										<span>
											Area {allotment.inventoryMergedId.unit1Id.saleableArea} +{" "}
											{allotment.inventoryMergedId.unit2Id.saleableArea} sq.ft
										</span>
									</>
								)}
							</div>
						</div>
						<div className={cssClasses.allotmentDateContent}>
							<div className={cssClasses.allotmentDateData}>
								<img src={AllotmentCalenderIcon} alt="Calender-check" />
								Alloted On:{" "}
							</div>
							<div className={cssClasses.allotmentDate}>
								{new Date(allotment.created_at).toDateString()},{" "}
								{new Date(allotment.created_at).toLocaleTimeString([], {
									hour: "2-digit",
									minute: "2-digit",
								})}
							</div>
						</div>
					</div>
					<div className={cssClasses.allotmentPriceBreakDown}>
						<div className={cssClasses.allotmentPrice1}>
							<div className={cssClasses.allotmentPriceText}>
								OCR :
								<img data-tooltip-id="ocr" src={AllotmentInfoIcon} alt="info" />
								<Tooltip id="ocr" content="Overall Capitalization Rate" />
							</div>
							<div>₹ {numberWithCommas(amtData.ocr)}</div>
						</div>
						<div className={cssClasses.allotmentPrice1}>
							<div className={cssClasses.allotmentPriceText}>
								GST :
								<img data-tooltip-id="gst" src={AllotmentInfoIcon} alt="info" />
								<Tooltip id="gst" content="Goods & Services Tax" />
							</div>
							<div>₹ {numberWithCommas(amtData.gst)}</div>
						</div>
						<Divider orientation="vertical" flexItem style={{ borderWidth: "1px" }} />
						<div className={cssClasses.allotmentPrice1}>
							<div className={cssClasses.allotmentPriceText}>
								Total Amount:
								<img data-tooltip-id="total-amt" src={AllotmentInfoIcon} alt="info" />
								<Tooltip id="total-amt" content="Total Amount" />
							</div>
							<div className={cssClasses.allotmentTotalAmount}>
								<span>₹ {numberWithCommas(amtData.ocr + amtData.gst)}</span>
							</div>
						</div>
					</div>
				</div>
				<div className={cssClasses.allotmentCardFooter}>
					<div className={cssClasses.balanceOCRGSTAmt}>
						<div className={cssClasses.allotmentpaidAmtContent}>
							<div>PAID AMOUNT</div>
							<div className={cssClasses.allotmentpaidAmt}>₹ {numberWithCommas(allotment.paidAmt.ocr + allotment.paidAmt.gst)}</div>
						</div>
						<div className={cssClasses.allotmentpaidAmtContent}>
							<div>REMAINING AMOUNT </div>
							<div className={cssClasses.allotmentpaidAmt}>
								₹{" "}
								{numberWithCommas(
									amtData.ocr + amtData.gst - (allotment.paidAmt.ocr + allotment.paidAmt.gst) > 0
										? amtData.ocr + amtData.gst - (allotment.paidAmt.ocr + allotment.paidAmt.gst)
										: 0
								)}
							</div>
						</div>
					</div>
					<div className={cssClasses.virtualAccBtn}>
						<div className={cssClasses.allotmentBtnView}>
							<Button
								btnName={"View Unit Cost"}
								clicked={() => setShowUnitCost(true)}
								style={{
									color: "#344054",
									backgroundColor: "#FFFFFF",
									fontSize: "1.4rem",
									lineHeight: "2rem",
									fontFamily: "Inter-Medium !important",
								}}
							></Button>
						</div>
					</div>
					<div className={cssClasses.virtualAccBtn}>
						<div className={cssClasses.paidAmt}>
							{vaDetailsHidden(allotment.kycFormFilled, newFlow(allotment.allotmentPaymentId)) ? (
								<div style={{ fontSize: "1.2rem", color: "#667085" }}>{VA_AFTER_KYC_TEXT}</div>
							) : (
							<Button
								disable={
									amtData.ocr + amtData.gst - (allotment.paidAmt.ocr + allotment.paidAmt.gst) <= 0 ||
									allotment.status === "Released" ||
									allotment.status === "Cancelled" ||
									allotment?.status?.includes("Refund")
								}
								btnName={"View Virtual Account Details"}
								clicked={() => {
									setShowVertualAccount(true);
								}}
								style={{
									color: "#fff",
									backgroundColor: "rgb(21, 112, 239)",
									fontSize: "1.4rem",
									lineHeight: "2rem",
									fontFamily: "Inter-Medium !important",
								}}
							></Button>
							)}
						</div>
					</div>
					<div className={cssClasses.virtualAccBtn}>
						{!allotment.isAgreementFormFilled ? (
							<div className={cssClasses.paidAmt}>
								<Button
									disable={
										allotment.status === "Released" || allotment.status === "Cancelled" || allotment?.status?.includes("Refund")
									}
									btnName="Fill Agreement confirmation form"
									clicked={() => {
										setOpenAgreementKYCModal(true);
									}}
									style={{
										color: "#fff",
										backgroundColor: "rgb(21, 112, 239)",
										fontSize: "1.4rem",
										lineHeight: "2rem",
										fontFamily: "Inter-Medium !important",
									}}
								/>
							</div>
						) : (
							<div className={cssClasses.paidAmt}>
								<Button
									disable={
										allotment?.CRM[0]?.sentForAgreement ||
										allotment?.CRM[0]?.skipCreateDraft ||
										allotment.status === "Released" ||
										allotment.status === "Cancelled" ||
										allotment?.status?.includes("Refund")
									}
									btnName="Edit Agreement confirmation form"
									clicked={() => {
										setOpenAgreementKYCModal(true);
									}}
									style={{
										color: "#fff",
										backgroundColor: "rgb(21, 112, 239)",
										fontSize: "1.4rem",
										lineHeight: "2rem",
										fontFamily: "Inter-Medium !important",
									}}
								/>
							</div>
						)}
					</div>
				</div>
			</Card>
			{showDetails && (
				<AllotmentDetails
					open={showDetails}
					handleClose={() => {
						setAllotmentDetails({});
						setShowDetails(false);
					}}
					data={allotmentDetails}
				/>
			)}
			{openCancelUnitModal && (
				<CancelUnit
					open={openCancelUnitModal}
					handleClose={() => {
						setOpenCancelUnitModal(false);
					}}
					allotmentDetails={allotmentDetails}
				/>
			)}
			{showVertualAccount && (
				<VirtualAccount
					loggedInUser={loggedInUser}
					open={showVertualAccount}
					handleClose={() => {
						setShowVertualAccount(false);
					}}
				/>
			)}
			{openAgreementKYCModal && (
				<AgreementKYC
					allotment={allotment}
					open={openAgreementKYCModal}
					handleClose={() => {
						setOpenAgreementKYCModal(false);
					}}
					edit={allotment.isAgreementFormFilled}
				/>
			)}
			{showUnitCost && (
				<UnitCost
					allotment={allotment}
					open={showUnitCost}
					handleClose={() => {
						setShowUnitCost(false);
					}}
				/>
			)}
		</>
	);
};

export default BalanceOCRGST;
